var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7083 16.3166L16.625 12.5V27.5L21.7083 23.6833L26.625 20L21.7083 16.3166ZM21.7083 16.3166L16.625 12.5V27.5L21.7083 23.6833L26.625 20L21.7083 16.3166ZM21.7083 16.3166L16.625 12.5V27.5L21.7083 23.6833L26.625 20L21.7083 16.3166ZM18.2917 6.78329V3.41663C14.9417 3.74996 11.8917 5.08329 9.425 7.09996L11.7917 9.48329C13.6417 8.04996 15.8583 7.08329 18.2917 6.78329ZM9.44167 11.8333L7.05833 9.46663C5.04167 11.9333 3.70833 14.9833 3.375 18.3333H6.74167C7.04167 15.9 8.00833 13.6833 9.44167 11.8333ZM6.74167 21.6666H3.375C3.70833 25.0166 5.04167 28.0666 7.05833 30.5333L9.44167 28.15C8.00833 26.3166 7.04167 24.1 6.74167 21.6666ZM9.425 32.9C11.8917 34.9166 14.9583 36.25 18.2917 36.5833V33.2166C15.8583 32.9166 13.6417 31.95 11.7917 30.5166L9.425 32.9ZM36.625 20C36.625 28.6 30.0917 35.7 21.7083 36.5833V33.2166C28.2417 32.35 33.2917 26.75 33.2917 20C33.2917 13.25 28.2417 7.64996 21.7083 6.78329V3.41663C30.0917 4.29996 36.625 11.4 36.625 20Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay2Icon);
export default __webpack_public_path__ + "static/media/play-2-icon.f50429c9782fec91272295546d643de2.svg";
export { ForwardRef as ReactComponent };